module.exports = __webpack_public_path__ + "static/img/mImg.0d8d01a0.png";